import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

export const H1 = styled.h1`
  font-family: Rubik;
  font-size: 36px;
  letter-spacing: 0.5px;
  margin: 0;

  @media (min-width: ${getBreakpoint('md')}px) {
    font-size: 48px;
  }
`

export const H2 = styled.h2`
  font-family: Rubik;
  font-size: 24px;
  letter-spacing: 0.5px;
  margin: 0;

  @media (min-width: ${getBreakpoint('md')}px) {
    font-size: 24px;
  }
`

export const H3 = styled.h3`
  font-family: Rubik;
  font-size: 32px;
  letter-spacing: 0.5px;
  margin: 0;
`

export const H4 = styled.h4`
  font-family: Rubik;
  font-size: 20px;
  letter-spacing: 0.5px;
  margin: 0;
`

export const H5 = styled.h5`
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0.5px;
  margin: 0;

  @media (min-width: ${getBreakpoint('md')}px) {
    font-size: 18px;
  }
`

export const H6 = styled.h6`
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0.5px;
  margin: 0;
`

export const Paragraph = styled.p`
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0.5px;
  margin: 0;
`

export const Body1 = styled.p`
  font-family: Rubik;
  font-size: 14px;
  letter-spacing: 0.5px;
  margin: 0;
`

export const Small = styled.small`
  display: block;
  font-family: Rubik;
  font-size: 12px;
  letter-spacing: 0.5px;
  margin: 0;
`
